import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { GET_TILES } from '../../../utils/apollo/tiles';
import {
  IGetTilesQuery,
  IGetTilesQueryVariables,
  PermissionKey,
} from '../../../utils/apollo/graphqlSchema';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { populateTiles, resetTiles } from '../../../redux/slices/tiles';
import usePermission from '../../../utils/hooks/permissionHooks';
import { ContentLoader } from '../../../components/Loaders';
import TileItem from './TileItem';
import NewTile from './NewTile';
import TileModals from './TileModals';

const Container = styled.section`
  display: flex;
  flex-wrap: nowrap;
  column-gap: 16px;
`;
const StyledLoader = styled(ContentLoader)`
  min-height: 74px;
`;

const Tiles = () => {
  const dispatch = useAppDispatch();

  const tiles = useAppSelector((state) => state.tiles.tiles);

  // Creating and updating tiles are available only for Admin
  const { checkIsPermitted } = usePermission();
  const isPermittedToEdit = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AdminEdit],
  });

  const handleLoadTiles = ({ tilesGet }: IGetTilesQuery) => {
    const tiles = tilesGet?.tiles;
    dispatch(populateTiles(tiles || []));
  };

  const { loading } = useQuery<IGetTilesQuery, IGetTilesQueryVariables>(
    GET_TILES,
    {
      onCompleted: handleLoadTiles,
    },
  );

  // clean-up on unmount
  useEffect(() => {
    return () => {
      dispatch(resetTiles());
    };
  }, [dispatch]);

  if (loading) {
    return <StyledLoader />;
  }

  return (
    <Container>
      {tiles?.length > 0 &&
        tiles.map((tile) => (
          <TileItem
            key={tile.id}
            tile={tile}
            isPermittedToEdit={isPermittedToEdit}
          />
        ))}

      {(!tiles?.length || tiles.length < 4) && isPermittedToEdit && <NewTile />}
      <TileModals />
    </Container>
  );
};

export default Tiles;
